import { Command } from '@approvalmax/types';
import { selectors } from 'modules/common';
import { State } from 'modules/data';
import { createSelector } from 'reselect';

import { getLoading } from './pageSelectors';

export const getManageUsersCommand: (state: State) => Command = createSelector(
    getLoading,
    selectors.company.canUpdateActiveCompanySettings,
    (loading, canManage) => {
        return {
            disabled: loading || !canManage,
            hidden: !canManage,
        };
    }
);
